import * as views from "../views";
import EmptyView from "@/core/components/EmptyView.vue";
import { i18nFormat } from "@/i18n.js";

export default [
  {
    path: "collectionpages",
    component: EmptyView,

    children: [
      {
        path: "",
        component: EmptyView,
        children: [
          {
            path: "",
            name: "CollectionPages",
            component: views.Pages,
            props: {
              type: "collectionpages"
            },
            meta: {
              headerVisible: true,
              headerTitle: i18nFormat("tc", "page.collectionpages", 2),
              headerDescription: i18nFormat("t", "page.collectionpagesDescription"),
              headerDomain: null,
              blockWhenNoPermission: true
            }
          },
          {
            path: "create",
            name: "CollectionPagesTemplate",
            component: views.PageTemplate,
            props: {
              type: "collectionpages"
            },
            meta: {
              headerVisible: false,
              headerTitle: i18nFormat("t", "page.btnCreate.title", {
                type: i18nFormat("tc", "page.collectionpages")
              }),
              headerDescription: i18nFormat("t", "page.collectionpagesDescription"),
              headerDomain: null,
              blockWhenNoPermission: true
            }
          }
        ]
      }
    ]
  },
  {
    path: "productpages",
    component: EmptyView,
    children: [
      {
        path: "",
        component: EmptyView,
        children: [
          {
            path: "",
            name: "ProductPages",
            component: views.Pages,
            props: {
              type: "productpages"
            },
            meta: {
              headerVisible: true,
              headerTitle: i18nFormat("tc", "page.productpages", 2),
              headerDescription: i18nFormat("t", "page.productpagesDescription"),
              headerDomain: null,
              blockWhenNoPermission: true
            }
          },
          {
            path: "create",
            name: "ProductPagesTemplate",
            component: views.PageTemplate,
            props: {
              type: "productpages"
            },
            meta: {
              headerVisible: false,
              headerTitle: i18nFormat("t", "page.btnCreate.title", {
                type: i18nFormat("tc", "page.productpages")
              }),
              headerDescription: i18nFormat("t", "page.productpagesDescription"),
              headerDomain: null,
              blockWhenNoPermission: true
            }
          }
        ]
      },
      {
        path: "assignments",
        name: "ProductAssignment",
        component: views.Assignment,
        props: {
          type: "productpages"
        },
        meta: {
          headerVisible: true,
          headerTitle: i18nFormat("t", "page.assignment.title", {
            type: i18nFormat("tc", "page.product")
          }),
          headerDescription: "",
          headerDomain: null,
          blockWhenNoPermission: true
        }
      }
    ]
  },
  {
    path: "subpages",
    component: EmptyView,
    children: [
      {
        path: "",
        name: "SubPages",
        component: views.Pages,
        props: {
          type: "subpages"
        },
        meta: {
          headerVisible: true,
          headerTitle: i18nFormat("tc", "page.newLandingPages", 2),
          headerDescription: i18nFormat("t", "page.subpagesDescription"),
          headerDomain: null,
          blockWhenNoPermission: true
        }
      },
      {
        path: "create",
        name: "SubPagesTemplate",
        component: views.PageTemplate,
        props: {
          type: "subpages"
        },
        meta: {
          headerVisible: false,
          headerTitle: i18nFormat("t", "page.btnCreate.title", {
            type: i18nFormat("tc", "page.newLandingPages")
          }),
          headerDescription: i18nFormat("t", "page.subpagesDescription"),
          headerDomain: null,
          blockWhenNoPermission: true,
          scrollTop: 0
        }
      }
    ]
  },
  {
    path: "landingpages",
    component: EmptyView,
    children: [
      {
        path: "",
        name: "LandingPages",
        component: views.Pages,
        props: {
          type: "subpages"
        },
        meta: {
          headerVisible: true,
          headerTitle: i18nFormat("tc", "page.newLandingPages", 2),
          headerDescription: i18nFormat("t", "page.subpagesDescription"),
          headerDomain: null,
          blockWhenNoPermission: true
        }
      },
      {
        path: "create",
        name: "LandingPagesTemplate",
        component: views.PageTemplate,
        props: {
          type: "subpages"
        },
        meta: {
          headerVisible: false,
          headerTitle: i18nFormat("t", "page.btnCreate.title", {
            type: i18nFormat("tc", "page.newLandingPages")
          }),
          headerDescription: i18nFormat("t", "page.subpagesDescription"),
          headerDomain: null,
          blockWhenNoPermission: true,
          scrollTop: 0
        }
      }
    ]
  },
  {
    path: "articlepages",
    component: EmptyView,
    children: [
      {
        path: "",
        name: "ArticlePages",
        component: views.Pages,
        props: {
          type: "articlepages"
        },
        meta: {
          headerVisible: true,
          headerTitle: i18nFormat("t", "page.blog"),
          headerDomain: null,
          headerDescription: i18nFormat("t", "page.articlepagesDescription"),
          blockWhenNoPermission: true
        }
      },
      {
        path: "create",
        name: "ArticlePagesTemplate",
        component: views.PageTemplate,
        props: {
          type: "articlepages"
        },
        meta: {
          headerVisible: false,
          headerTitle: i18nFormat("t", "page.btnCreate.title", {
            type: i18nFormat("tc", "page.articlepages")
          }),
          headerDescription: i18nFormat("t", "page.articlepagesDescription"),
          headerDomain: null,
          blockWhenNoPermission: true
        }
      }
    ]
  },
  {
    path: "homepages",
    component: EmptyView,
    children: [
      {
        path: "",
        name: "HomePages",
        component: views.Pages,
        props: {
          type: "homepages"
        },
        meta: {
          headerVisible: true,
          headerTitle: i18nFormat("tc", "page.homepages", 2),
          headerDescription: i18nFormat("t", "page.homepagesDescription"),
          headerDomain: null,
          blockWhenNoPermission: true
        }
      },
      {
        path: "create",
        name: "HomePagesTemplate",
        component: views.PageTemplate,
        props: {
          type: "homepages"
        },
        meta: {
          headerVisible: false,
          headerTitle: i18nFormat("t", "page.btnCreate.title", {
            type: i18nFormat("tc", "page.homepages")
          }),
          headerDescription: i18nFormat("t", "page.homepagesDescription"),
          headerDomain: null,
          blockWhenNoPermission: true
        }
      }
    ]
  },
  {
    path: "thankyou",
    component: views.Thanks,
    meta: {
      headerVisible: false,
      headerDomain: null
    }
  },
  {
    path: "/pricing-onboarding/:id",
    component: views.PricingOnboarding,
    name: "PricingOnboarding",
    meta: {
      headerVisible: false,
      headerDomain: null
    }
  }
];
